import React, { Component, Fragment } from "react";
import DeleteModel from "./DeleteModel";
import AppContext from "../../../contexts/AppContext";
import ApplicantModal from "./ApplicantModal";

class List extends Component {
    state = {
        delete: false,
        item: {},
        showApplicantModal: false,
        baseUrl: process.env.NODE_ENV !== "production"
        ? "http://localhost:8000/"
        : "/"
    };

    delete = () => {
        return this.props.delete(this.props.item.id);
    };
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    toggleApplicantModal = () => {
        this.setState({ showApplicantModal: !this.state.showApplicantModal });
    };

    render() {
        return (
            <Fragment>
                {this.state.showApplicantModal ? (
                    <ApplicantModal
                        toggleApplicantModal={this.toggleApplicantModal}
                        item={this.props.item}
                    ></ApplicantModal>
                ) : null}

                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <img
                                    src={
                                        this.props.item.user !== null ? this.props.item.user.image : null
                                    }
                                    className="cc-image-lg rounded-circle"
                                    alt=""
                                />
                            </div>
                            <div className="col ml-n2">
                                <h4 className="mb-1 name">
                                    { this.props.item.user !== null ? this.props.item.user.name : null}                                    
                                </h4>
                                <p className="small mb-0">
                                    { this.props.item.user !== null ? this.props.item.user.email : null}
                                </p>
                            </div>
                        </div>
                    </td>
                    <td className="large">{this.props.item.title}</td>

                    <td onClick={this.toggleApplicantModal}>
                        <span className="badge badge-soft-primary ml-1 mt-n1 p-2">
                            {this.props.item.applicants}
                        </span>
                    </td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                    <td>{this.props.item.job_type}</td>
                    <td>{this.props.item.state}</td>
                    <td className="text-right large">
                        <a
                            href={`${ this.props.item.jobLink }`}
                            className="btn btn-info btn-sm"
                            target="_blank"
                        >
                            View
                        </a>
                        {this.props.item.state === "active" ||
                            this.props.item.state === "saved" ? 
                                <a
                                    href={`/admin/job-listings/update/${this.props.item.id}`}
                                    onClick={this.toggleUpdate}
                                    className="btn btn-success btn-sm  ml-2"
                                >
                                    Edit
                            </a>
                            
                             : null}

                        <button
                            onClick={this.toggleDelete}
                            type="button"
                            className="btn btn-danger btn-sm ml-2"
                        >
                            Delete
                        </button>
                    </td>
                </tr>
                {this.state.delete === true ? (
                    <DeleteModel
                        delete={this.delete}
                        hideDelete={this.toggleDelete}
                    ></DeleteModel>
                ) : null}
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/admin/jobListing/List.js